import React, { Component } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import './App.css';

import Footer from './Footer/Footer';
import NavigationBar from './NavigationBar/NavigationBar';
import NewsPage from './News/NewsPage';
import EventsPage from './Events/EventsPage';
import LoginPage from './Login/LoginPage';
import ProfilePage from './Profile/ProfilePage';
import EventDetailedPage from './Events/EventDetailed/EventDetailedPage';
import UnauthorizedPage from '../UnauthorizedPage';
import ForbiddenPage from '../ForbiddenPage';
import PageDetailsPage from './Pages/PageDetailsPage';
import MembersPage from './Members/MembersPage';

class App extends Component {
    render() {
        return (
            <>
                <h1 className="site-heading text-center d-none d-lg-block">Villanykari Szakestély</h1>
                <NavigationBar />
                <div className="page-content">
                    <Routes>
                        <Route path="news" element={<NewsPage />}/>
                        <Route path="pages/:id/:name?" element={<PageDetailsPage />}/>
                        <Route path="members/" element={<MembersPage />}/>
                        <Route path="events/:id/:name?" element={<EventDetailedPage />}/>
                        <Route path="events/:id" element={<EventDetailedPage />}/>
                        <Route path="events" element={<EventsPage />}/>
                        <Route path="login" element={<LoginPage />}/>
                        <Route path="profile" element={<ProfilePage />}/>
                        <Route path="forbidden" element={<ForbiddenPage />}/>
                        <Route path="unauthorized" element={<UnauthorizedPage />}/>
                        <Route index render={() => <Navigate to="news" /> }/>
                    </Routes>
                </div>
                <Footer />
            </>
        );
    }
}

export default App;
